<template>
	<div>
		<el-form ref="cusForm" :rules="rules" :model="item" v-for="(item,index) in TemplateList" :key="index"
			label-position="left" label-width="100px">
			<el-form-item :label="item.name+'：'" :prop="JSON.parse(item.required) ? 'value' : ''">
				<el-input class="style" :disabled="disabled" v-if="item.templateType == '0'" v-model="item.value"
					:placeholder="item.placeholder" clearable />
				<el-date-picker class="style" :disabled="disabled" v-if="item.templateType == '1'" v-model="item.value" clearable
					align="center" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :placeholder="item.placeholder" />
				<el-select class="style" :disabled="disabled" v-if="item.templateType == '2'" v-model="item.value" clearable
					:placeholder="item.placeholder">
					<el-option v-for="item_ in item.options" :key="item_" :label="item_" :value="item_" />
				</el-select>
				<div class="style" v-if="item.templateType == '3'">
					<el-upload class="upload-demo" :disabled="disabled" action="https://jsonplaceholder.typicode.com/posts/">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">{{item.placeholder}}</div>
					</el-upload>
				</div>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props: {
			TemplateList: {
				type: Array
			},
			customObj: {
				type: Object
			},
			disabled:{
				type:Boolean
			}
		},
		data() {
			return {
				rules: {
					value: [{
						required: true,
						message: '该项为必填项！请完善操作',
						trigger: 'blur'
					}]
				}
			}
		}
	}
</script>

<style scoped>
	.style {
		width: 250px;
	}
</style>